import React, { Component } from 'react';
import './../css/App.css';
import appstore_image_stickers from './../images/appstore_image_stickers.jpg';
import appstore_image_strut from './../images/appstore_image_strut.jpg';
import InfoTile from './../js/InfoTile'


class Links extends Component {
  render() {
    return (
      <div className="press">
        <div className="header">LINKS</div>
          <InfoTile href="https://foodbabyny.myshopify.com/"
            title="FoodBabyNY Merch"
            description="Get some cute @foodbabyny-themed merch"
            imagePath="http://foodbabyny.com/links/links_tshirt.jpg"
          ></InfoTile>
        <InfoTile href="https://www.bookcameo.com/foodbabyny"
          title="Food Baby on Cameo"
          description="Book a personalized video from Food Baby"
          imagePath="http://foodbabyny.com/links/links_cameo.jpg"
        ></InfoTile>
        <InfoTile href="https://itunes.apple.com/us/app/foodbabyny-stickers/id1163929313?mt=8"
          title="FoodBabyNY Stickers"
          description="Text silly photos of Matty and Sammy to your friends"
          imagePath={appstore_image_stickers}
        ></InfoTile>
        <InfoTile href="http://strutapp.com"
          title="Strut"
          description="Before he was obsessed with his children and food, @mikejchau made a fun navigation game"
          imagePath={appstore_image_strut}
        ></InfoTile>
        <br/>
        <InfoTile href="http://www.foodnetwork.com/restaurants/photos/new-york-citys-best-places-to-eat-near-tourist-destinations.html?vty=restaurants/packages/city-guides/new-york-citys-best-places-to-eat-near-tourist-destinations.html"
          title="Food Network Guide by @foodbabyny"
          description="New York City's Best Eats Near Tourist Destinations"
          imagePath="http://foodbabyny.com/links/links_foodnetwork01.jpg"
        ></InfoTile>
        <InfoTile href="http://www.foodnetwork.com/restaurants/photos/where-to-get-the-best-doughnuts-in-new-york-city.html"
          title="Food Network Guide by @foodbabyny"
          description="Where to Get the Best Doughnuts in New York City"
          imagePath="http://foodbabyny.com/links/links_foodnetwork02.jpg"
        ></InfoTile>
        <InfoTile href="http://www.foodnetwork.com/restaurants/photos/kid-friendly-meals-in-philadelphia.html"
          title="Food Network Guide by @foodbabyny"
          description="Kid-Friendly Eats in Philadelphia"
          imagePath="http://foodbabyny.com/links/links_foodnetwork03.jpg"
        ></InfoTile>
      </div>
    );
  }
}

export default Links;



// WEBPACK FOOTER //
// ./src/js/Links.js